import { Key, useCallback } from 'react'
import { RenderCellProps } from '@bst/react-data-grid'
import { InvitationStrategy, UserDTO } from '../../../apiclients/bstinsights'
import { CheckboxCell } from '../Views/CheckboxCell'
import { UserNameCell } from '../Views/UserNameCell'
import { isUserInvitable } from './utils/isUserInvitable'
import { USER_ROLES } from '../../../stores/UserManagement/constants'

type Props = {
  selected: Key[]
  disabled: boolean
  columnKey: string
  invitationStrategy: InvitationStrategy
  handleSelectRows: (keys: Key[]) => void
  handleRoleChange: (roleId: number, user: UserDTO, isChecked: boolean) => void
} & RenderCellProps<UserDTO, unknown>

export const useCellRender = () => {
  return useCallback(({
    selected,
    disabled,
    columnKey,
    invitationStrategy,
    handleSelectRows,
    handleRoleChange,
    ...props
  }: Props) => {
    const column = props.column;
    const roleId = USER_ROLES[columnKey]
    if (column.frozen) {
      return (
        <UserNameCell
          {...props}
          selected={selected}
          invitationStrategy={invitationStrategy}
          isUserInvitable={isUserInvitable}
          handleSelectRows={handleSelectRows}
        />
      );
    }
    if (roleId) {
      return (
        <CheckboxCell
          {...props}
          disabled={disabled}
          checked={props.row.groups?.includes(roleId)}
          handleCheckedChange={(checked) =>
            handleRoleChange(
              roleId,
              props.row,
              checked
            )
          }
        />
      );
    }
    return (
      <span data-testid={column.key}>
        {props.row[column.key as keyof UserDTO]}
      </span>
    );
  }, [])
}